import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
// import Timer from "../widget/timer";
import Footer from "../layout/footer";
import Down_Arrow from '../../image/header/down_arrow.png';
import Left_Arrow from '../../image/header/left-arrow.png';
import './comp.css';
import { Link } from "react-router-dom";

import Sub1_Judge1 from '../../image/comp/sub1/MrTaoTan.jpg';
import Sub1_Judge2 from '../../image/comp/sub1/ProfBorongLin.jpg';
import Sub1_Judge3 from '../../image/comp/sub1/ProfDanWang.jpg';
import Sub1_Judge4 from '../../image/comp/sub1/ProfLindaXiao.jpg';
import Sub1_Judge5 from '../../image/comp/sub1/IrSammyYeung.jpg';
import Sub1_Judge6 from '../../image/comp/sub1/MrSpencerFung.jpg';
import Sub1_Judge7 from '../../image/comp/sub1/MrYinShi.jpg';

class Comp extends Component {
    state = {
        isScrollToSubMenu: false,
        SubMenuHeight: 0,
        sub1: true,
        sub2: false,
        sub3: false,
        sub4: false,
        sub5: false,
        sub6: false,
        sub7: false,
        sub8: false,
        sub9: false,
    }
    clickScrollSub(n) {
        let subX = document.getElementById("comp-sub-menu-gp");

        subX.scrollLeft += n; // Scroll n px
    }

    handleScroll = () => {
        let ScrollNow = window.scrollY;
        let topMenuHeight = 135;
        if (window.innerWidth <= 593) {
            topMenuHeight = window.innerWidth * 0.135;
        } else if (window.innerWidth <= 1100) {
            topMenuHeight = 80;
        }

        var subMenuTop = this.state.SubMenuHeight - topMenuHeight;
        if (ScrollNow >= subMenuTop) {
            setTimeout(() => {
                this.setState({ isScrollToSubMenu: true })
            }, 0);
        } else {
            setTimeout(() => {
                this.setState({ isScrollToSubMenu: false })
            }, 0);
        }
    }
    updateSubMenuHeight = () => {
        const SubMenuHeight = document.getElementById("comp-sub-menu").offsetTop;
        setTimeout(() => {
            this.setState({ SubMenuHeight: SubMenuHeight });
        }, 0);
    }
    updateSub = (n) => {
        this.goToSub();

        switch (n) {
            case 1:
                setTimeout(() => {
                    this.setState({ sub1: true, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;
            case 2:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: true, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;

            case 3:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: true, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;

            case 4:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: true, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;

            case 5:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: true, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;
            case 6:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: true, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;
            case 7:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: true, sub8: false, sub9: false, });
                }, 0);
                break;
            case 8:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: true, sub9: false, });
                }, 0);
                break;
            case 9:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: true, });
                }, 0);
                break;
            default:
                break;
        }
    }
    checkSub = (n) => {
        switch (n) {
            case "Background":
                this.updateSub(1);
                break;
            case "Description":
                this.updateSub(2);
                break;
            case "Evaluation":
                this.updateSub(3);
                break;
            case "Prizes":
                this.updateSub(4);
                break;
            case "Timeline":
                this.updateSub(5);
                break;
            case "Acknowledgements":
                this.updateSub(6);
                break;
            case "Data":
                this.updateSub(7);
                break;
            case "Rules":
                this.updateSub(8);
                break;
            case "Results":
                this.updateSub(9);
                break;
            default:
                break;

        }
    }
    goToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "initial"
        });
    }
    goToSub() {
        let subHeight = document.getElementById("comp-sub").offsetTop;
        let topMenuHeight = 135;
        let subMenuHeight = 74;

        if (window.innerWidth <= 593) {
            topMenuHeight = window.innerWidth * 0.135;
            subMenuHeight = window.innerWidth * 0.11068;
        } else if (window.innerWidth <= 480) {
            topMenuHeight = 80;
            subMenuHeight = window.innerWidth * 0.11068;
        } else if (window.innerWidth <= 930) {
            topMenuHeight = 80;
        }


        window.scrollTo({
            top: subHeight - topMenuHeight - subMenuHeight,
            left: 0,
        });
    }
    goToGroup(t) {
        let subHeight = document.getElementById(t).offsetTop;
        let topMenuHeight = 135;
        let subMenuHeight = 74;

        if (window.innerWidth <= 593) {
            topMenuHeight = window.innerWidth * 0.135;
            subMenuHeight = window.innerWidth * 0.11068;
        } else if (window.innerWidth <= 480) {
            topMenuHeight = 80;
            subMenuHeight = window.innerWidth * 0.11068;
        } else if (window.innerWidth <= 930) {
            topMenuHeight = 80;
        }


        window.scrollTo({
            top: subHeight - topMenuHeight - subMenuHeight,
            left: 0,
        });
    }

    componentDidMount() {
        this.updateSubMenuHeight();
        window.addEventListener('scroll', this.handleScroll);

        var sub = window.location.hash;
        sub = sub.slice(1);
        this.checkSub(sub);
    };
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        var sub = window.location.hash;
        sub = sub.slice(1);

        this.checkSub(sub);
    }
    render() {
        const { t } = this.props;
        const { isScrollToSubMenu, sub1, sub2, sub3, sub4, sub5, sub6, sub7, sub8, sub9 } = this.state;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('comp-meta-title')}</title>
                    <meta name="title" content={t('comp-meta-title')} />
                    <meta name="description" content={t('comp-meta-description')} />
                    <meta name="keywords" content={t('comp-meta-keywords')} />
                </MetaTags>
                <div className="div-comp">
                    <div className="comp-intro">
                        <div className="container-fluid d-flex justify-content-center div-comp-intro">
                            <div>
                                <div className="comp-intro-headline-1 text-center">{t('comp-intro-headline-1-1')}<br className="d-md-none" />{t('comp-intro-headline-1-2')}</div>
                                <div className="comp-intro-headline-2 text-center my-2">{t('comp-intro-headline-2')}</div>
                                <div className="comp-intro-headline-3 text-center mt-3"><span>{t('comp-intro-headline-3')}</span><br className={t('TC_SC_none d-md-none')} /><strong className="comp-intro-headline-4">{t('comp-intro-headline-4')}</strong><span>{t('comp-intro-headline-5')}</span></div>

                                <div className="d-flex justify-content-center text-center mt-3">
                                    <div className="col-12 col-md-10 px-3"><span className={t('TXT_bold')}>{t('comp-intro-text-1')}</span></div>
                                </div>
                                <div className="d-flex flex-column flex-md-row justify-content-center align-items-center align-items-md-stretch my-5">
                                    <Link className="card comp-card-1 p-1 my-4 m-sm-4 m-md-2 h-max no_border" aria-current="page" to={match + "/competition/"} onClick={() => this.updateSub(1)}>
                                        <div className="comp-card-item-1 text-center d-flex justify-content-center align-items-center px-4 w-100"><div><div className="comp-card-text-1">{t('Build Your')}</div><div className="comp-card-text-2">{t('AI Model')}</div></div></div>
                                        <div className="card-body sub-theme-1-bar text-center p-1">
                                            <p className="card-text"><strong>{t('sub-theme-1-bar-text')}</strong></p>
                                        </div>
                                        <div className="card-body d-flex align-items-center">
                                            <p className="card-text text-center"><strong>{t('sub-theme-1-text')}</strong></p>
                                        </div>
                                    </Link>
                                    <Link className="card comp-card-2 p-1 my-4 m-sm-4 m-md-2 h-max no_border" aria-current="page" to={match + "/competition2/"} onClick={() => this.updateSub(1)}>
                                        <div className="comp-card-item-2 text-center d-flex justify-content-center align-items-center px-4 w-100"><div><div className="comp-card-text-1">{t('Pitch Your')}</div><div className="comp-card-text-3">{t('Innovative Proposal')}</div></div></div>
                                        <div className="card-body sub-theme-2-bar text-center p-1">
                                            <p className="card-text"><strong>{t('sub-theme-2-bar-text')}</strong></p>
                                        </div>
                                        <div className="card-body d-flex align-items-center">
                                            <p className="card-text text-center"><strong>{t('sub-theme-2-text')}</strong></p>
                                        </div>
                                    </Link>
                                </div>
                                <div className="d-flex justify-content-center text-center comp-intro-text my-4">
                                    <div className="col-12 col-md-10 px-3"><strong>{t('comp-intro-text-2')}</strong></div>
                                </div>
                                {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border d-flex justify-content-center"><button className="btn btn-highlight01 w-100 py-1"><strong>{t('Join the Competition')}</strong></button></a> */}
                                {/* <div className="d-flex justify-content-center my-4">
                                    <Timer date="5/23/2025 23:59 GMT+8" type="comp" />
                                </div> */}
                                <div className={t('d-flex justify-content-center div-comp-intro-btn')}>
                                    {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn_conf_comp btn_JnComp TXT_medium">{t('APPLY NOW')}</button></a> */}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-start div-comp-intro-banner">
                            <div className="comp-intro-banner"></div>
                        </div>
                    </div>
                    <div id="comp-sub-menu" className={isScrollToSubMenu ? "fixed comp-sub-menu" : "comp-sub-menu"}>
                        <div className="d-flex d-sm-block justify-content-center">
                            <div className="d-none d-sm-flex justify-content-center">
                                <div className="comp-sub-menu-item comp-sub-menu-item-1 text-center px-4 mt-2" onClick={() => this.updateSub(1)}>
                                    <strong>{t('comp-sub-menu-item-1')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-2 text-center px-4 mt-2" onClick={() => this.updateSub(2)}>
                                    <strong>{t('comp-sub-menu-item-2')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-3 text-center px-4 mt-2" onClick={() => this.updateSub(3)}>
                                    <strong>{t('comp-sub-menu-item-3')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-4 text-center px-4 mt-2" onClick={() => this.updateSub(4)}>
                                    <strong>{t('comp-sub-menu-item-4')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-9 text-center px-4 mt-2" onClick={() => this.updateSub(9)}>
                                    <strong>{t('comp-sub-menu-item-9')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-end comp-sub-menu-item-5 text-center px-4 mt-2" onClick={() => this.updateSub(5)}>
                                    <strong>{t('comp-sub-menu-item-5')}</strong>
                                </div>
                            </div>
                            <div className="d-none d-sm-flex justify-content-center">
                                <div className="comp-sub-menu-item comp-sub-menu-item-6 text-center px-4 my-1" onClick={() => this.updateSub(6)}>
                                    <strong>{t('comp-sub-menu-item-6')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-7 text-center px-4 my-1" onClick={() => this.updateSub(7)}>
                                    <strong>{t('comp-sub-menu-item-7')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-end comp-sub-menu-item-8 text-center px-4 my-1" onClick={() => this.updateSub(8)}>
                                    <strong>{t('comp-sub-menu-item-8')}</strong>
                                </div>
                                {/* <div className="d-flex justify-content-center align-items-end div-btn_comp-sub-menu">
                                    <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn btn-highlight01 w-100">{t('APPLY NOW')}</button></a>
                                </div>  */}
                            </div>
                            <div className="d-flex d-sm-none justify-content-center">
                                <div className="left-arrow p-2 d-flex justify-content-center" onClick={() => this.clickScrollSub(-150)}><img src={Left_Arrow} className="mx-auto d-block" alt=""></img></div>

                                <div id="comp-sub-menu-gp" className="comp-sub-menu-gp d-flex mt-2">
                                    {/* <div className="d-flex justify-content-center div-btn_comp-sub-menu">
                                        <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn btn-highlight01 w-100 text-nowrap">{t('APPLY NOW')}</button></a>
                                    </div>  */}
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-1 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(1)}>
                                        <span>{t('comp-sub-menu-item-1')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-2 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(2)}>
                                        <span>{t('comp-sub-menu-item-2')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-3 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(3)}>
                                        <span>{t('comp-sub-menu-item-3')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-4 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(4)}>
                                        <span>{t('comp-sub-menu-item-4')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-9 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(9)}>
                                        <span>{t('comp-sub-menu-item-9')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-5 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(5)}>
                                        <span>{t('comp-sub-menu-item-5')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-6 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(6)}>
                                        <span>{t('comp-sub-menu-item-6')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-7 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(7)}>
                                        <span>{t('comp-sub-menu-item-7')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-end comp-sub-menu-item-8 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(8)}>
                                        <span>{t('comp-sub-menu-item-8')}</span>
                                    </div>
                                    <div></div>
                                </div>
                                <div className="right-arrow p-2 d-flex justify-content-center" onClick={() => this.clickScrollSub(150)}><img src={Left_Arrow} className="mx-auto d-block" alt=""></img></div>

                            </div>
                        </div>
                    </div>
                    <div id="comp-sub" className="d-flex justify-content-center comp-sub">
                        <div className={sub1 ? "d-block col-12" : "d-none"}>
                            <div className="container-fluid col-12 col-md-10 d-flex justify-content-center">
                                <div className="col-12">
                                    <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-1-headline')}</div>
                                    <div className="comp-sub-description">
                                        <p>{t('comp-sub-1-text-1')}</p>
                                        <p>{t('comp-sub-1-text-2')}</p>
                                        <p>{t('comp-sub-1-text-3')}</p>
                                    </div>
                                    <div className="comp-sub-extra d-flex justify-content-center">
                                        <div className="d-flex justify-content-center col-12 col-md-10">
                                            <div className="d-flex align-items-center">
                                                <div className="comp-sub-1-extra-number d-flex align-items-center justify-content-center">
                                                    <span className={t('TXT_bold comp-sub-1-extra-number-1')}>1</span>
                                                </div>
                                            </div>
                                            <div className="comp-sub-1-extra-box comp-sub-1-extra-box-1 d-flex py-2">
                                                <div className="comp-sub-1-icon d-flex align-items-center justify-content-center">
                                                    <div className="comp-sub-1-icon-1"></div>
                                                </div>
                                                <div className="comp-sub-description-2 d-flex align-items-center">{t('comp-sub-1-text-4')}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-extra d-flex justify-content-center">
                                        <div className="d-flex justify-content-center col-12 col-md-10">
                                            <div className="d-flex align-items-center">
                                                <div className="comp-sub-1-extra-number d-flex align-items-center justify-content-center">
                                                    <span className={t('TXT_bold comp-sub-1-extra-number-2')}>2</span>
                                                </div>
                                            </div>
                                            <div className="comp-sub-1-extra-box comp-sub-1-extra-box-2 d-flex py-2">
                                                <div className="comp-sub-1-icon d-flex align-items-center justify-content-center">
                                                    <div className="comp-sub-1-icon-2"></div>
                                                </div>
                                                <div className="comp-sub-description-2 d-flex align-items-center">{t('comp-sub-1-text-5')}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-extra d-flex justify-content-center">
                                        <div className="d-flex justify-content-center col-12 col-md-10">
                                            <div className="d-flex align-items-center">
                                                <div className="comp-sub-1-extra-number d-flex align-items-center justify-content-center">
                                                    <span className={t('TXT_bold comp-sub-1-extra-number-3')}>3</span>
                                                </div>
                                            </div>
                                            <div className="comp-sub-1-extra-box comp-sub-1-extra-box-3 d-flex py-2">
                                                <div className="comp-sub-1-icon d-flex align-items-center justify-content-center">
                                                    <div className="comp-sub-1-icon-3"></div>
                                                </div>
                                                <div className="comp-sub-description-2 d-flex align-items-center">{t('comp-sub-1-text-6')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub2 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-2-headline')}</div>
                            <div className="container-fluid-1 d-flex justify-content-center"><div className={t('comp-sub-detail text-center TXT_medium_normal')}>{t('comp-sub-2-detail')}</div></div>
                            <div className="collapsed comp-sub-part comp-sub-2-part-1 d-flex justify-content-center" role="button" data-bs-toggle="collapse" data-bs-target="#comp-sub-2-part-a" aria-expanded="false" aria-controls="comp-sub-2-part-a">
                                <div className="container-fluid d-flex justify-content-center">
                                    <div className="d-flex flex-column flex-md-row align-items-center col-11">
                                        <div className={t('comp-sub-part-no col-12 col-md-2 d-flex align-items-center justify-content-start justify-content-md-center TXT_medium')}>
                                            {t('comp-sub-2-part-no-1')}
                                            <div className="d-md-none comp-sub-part-icon comp-sub-part-icon-1"></div>
                                        </div>
                                        <div className={t('comp-sub-part-headline col-12 col-md-9 d-flex align-items-center TXT_medium')}>{t('comp-sub-2-part-headline-1')}</div>
                                        <div className="col-1 d-none d-md-flex align-items-center justify-content-center">
                                            <div className="comp-sub-part-icon comp-sub-part-icon-1"></div>
                                        </div>

                                    </div>
                                    <div className="col-1 d-flex align-items-center justify-content-center">
                                        <img src={Down_Arrow} className="comp-sub-part-arrow" alt=""></img>
                                    </div>
                                </div>
                            </div>
                            <div id="comp-sub-2-part-a" className="collapse">
                                <div className="container-fluid d-flex justify-content-center col-12">
                                    <div className="comp-sub-part-detail comp-sub-part-detail-1 col-12 col-md-8">
                                        <div className="comp-sub-description">
                                            <p>{t('comp-sub-2-text-1')}</p>
                                            <p><strong>{t('comp-sub-2-text-2')}</strong><br />{t('comp-sub-2-text-3')}</p>
                                            <p>{t('comp-sub-2-text-4')}</p>
                                            <p><strong>{t('comp-sub-2-text-5')}</strong><br />{t('comp-sub-2-text-6')}</p>
                                            <p><strong>{t('comp-sub-2-text-7')}</strong><br />{t('comp-sub-2-text-8')}</p>
                                            <p>{t('comp-sub-2-text-9')}</p>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <div className="comp-sub-2-image"></div>
                                        </div>
                                        <div className="comp-sub-description">
                                            <p><strong>{t('comp-sub-2-text-10')}</strong><br />{t('comp-sub-2-text-11')}<a href={t('comp-sub-2-text-11-url')} target="_blank" rel="noopener noreferrer">{t('comp-sub-2-text-11-short-url')}</a>{t('comp-sub-2-text-12')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="collapsed comp-sub-part comp-sub-2-part-2 d-flex justify-content-center" role="button" data-bs-toggle="collapse" data-bs-target="#comp-sub-2-part-b" aria-expanded="false" aria-controls="comp-sub-2-part-b">
                                <div className="container-fluid d-flex justify-content-center">
                                    <div className="d-flex flex-column flex-md-row align-items-center col-11">
                                        <div className={t('comp-sub-part-no col-12 col-md-2 d-flex align-items-center justify-content-start justify-content-md-center TXT_medium')}>
                                            {t('comp-sub-2-part-no-2')}
                                            <div className="d-md-none comp-sub-part-icon comp-sub-part-icon-2"></div>
                                        </div>
                                        <div className={t('comp-sub-part-headline col-12 col-md-9 d-flex align-items-center TXT_medium')}>{t('comp-sub-2-part-headline-2')}</div>
                                        <div className="col-1 d-none d-md-flex align-items-center justify-content-center">
                                            <div className="comp-sub-part-icon comp-sub-part-icon-2"></div>
                                        </div>

                                    </div>
                                    <div className="col-1 d-flex align-items-center justify-content-center">
                                        <img src={Down_Arrow} className="comp-sub-part-arrow" alt=""></img>
                                    </div>
                                </div>
                            </div>
                            <div id="comp-sub-2-part-b" className="collapse">
                                <div className="container-fluid d-flex justify-content-center col-12">
                                    <div className="comp-sub-part-detail comp-sub-part-detail-2 col-12 col-md-8">
                                        <div className="comp-sub-description">
                                            <p>{t('comp-sub-2-text-13')}</p>
                                            <p>{t('comp-sub-2-text-14')}</p>
                                            <p>{t('comp-sub-2-text-15')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub3 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-3-headline')}</div>
                            <div className={t('collapsed comp-sub-part-sm comp-sub-2-part-1 d-flex justify-content-center')} role="button" data-bs-toggle="collapse" data-bs-target="#comp-sub-3-part-a" aria-expanded="false" aria-controls="comp-sub-3-part-a">
                                <div className="container-fluid d-flex justify-content-center">
                                    <div className="d-flex flex-column flex-md-row align-items-center col-11">
                                        <div className={t('comp-sub-part-no-sm col-12 col-md-2 d-flex align-items-center justify-content-start justify-content-md-center TXT_medium')}>
                                            {t('comp-sub-2-part-no-1')}
                                        </div>
                                        <div className={t('comp-sub-part-headline col-12 col-md-9 d-flex align-items-center TXT_medium')}></div>
                                        <div className="col-1 d-none d-md-flex align-items-center justify-content-center">
                                        </div>
                                    </div>
                                    <div className="col-1 d-flex align-items-center justify-content-center">
                                        <img src={Down_Arrow} className="comp-sub-part-arrow" alt=""></img>
                                    </div>
                                </div>
                            </div>
                            <div id="comp-sub-3-part-a" className="collapse">
                                <div className="container-fluid d-flex justify-content-center col-12">
                                    <div className="comp-sub-part-detail comp-sub-part-detail-2 col-12 col-md-10">
                                        <div className="comp-sub-description">
                                            <p>
                                                <span>{t('comp-sub-3-text-1')}</span><br />
                                                <div className="comp-sub-3-part-list-2">
                                                    <ul>
                                                        <li className="comp-sub-3-part-list-2-inner">
                                                            <span>{t('comp-sub-3-text-2')}</span><br />
                                                            <div className="comp-sub-3-image"></div>
                                                            <span>{t('comp-sub-3-text-3')}</span>
                                                            <ul>
                                                                <li><span>{t('comp-sub-3-text-4')}</span></li>
                                                                <li><span>{t('comp-sub-3-text-5')}</span></li>
                                                                <li><span>p<sub>i</sub> {t('comp-sub-3-text-6')}</span></li>
                                                                <li><span>a<sub>max</sub> {t('comp-sub-3-text-7')} a<sub>min</sub> {t('comp-sub-3-text-8')}</span></li>
                                                            </ul>
                                                        </li>
                                                        <li className="comp-sub-3-part-list-2-inner"><span>{t('comp-sub-3-text-9')}</span></li>
                                                        <li className="comp-sub-3-part-list-2-inner"><span>{t('comp-sub-3-text-10')}</span></li>
                                                    </ul>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={t('collapsed comp-sub-part-sm comp-sub-2-part-2 d-flex justify-content-center')} role="button" data-bs-toggle="collapse" data-bs-target="#comp-sub-3-part-b" aria-expanded="false" aria-controls="comp-sub-3-part-b">
                                <div className="container-fluid d-flex justify-content-center">
                                    <div className="d-flex flex-column flex-md-row align-items-center col-11">
                                        <div className={t('comp-sub-part-no-sm col-12 col-md-2 d-flex align-items-center justify-content-start justify-content-md-center TXT_medium')}>
                                            {t('comp-sub-2-part-no-2')}
                                        </div>
                                        <div className={t('comp-sub-part-headline col-12 col-md-9 d-flex align-items-center TXT_medium')}></div>
                                        <div className="col-1 d-none d-md-flex align-items-center justify-content-center">
                                        </div>
                                    </div>
                                    <div className="col-1 d-flex align-items-center justify-content-center">
                                        <img src={Down_Arrow} className="comp-sub-part-arrow" alt=""></img>
                                    </div>
                                </div>
                            </div>
                            <div id="comp-sub-3-part-b" className="collapse">
                                <div className="container-fluid d-flex justify-content-center col-12">
                                    <div className="comp-sub-part-detail comp-sub-part-detail-3 col-12 col-md-10">
                                        <div className="comp-sub-description">
                                            <p>{t('comp-sub-3-text-11')}</p>
                                            <p>
                                                <div className="comp-sub-3-part-list-3">
                                                    <ul>
                                                        <li className="comp-sub-3-part-list-3-inner">
                                                            <span>{t('comp-sub-3-text-12')}</span>
                                                        </li>
                                                        <li className="comp-sub-3-part-list-3-inner">
                                                            <span>{t('comp-sub-3-text-13')}</span>
                                                        </li>
                                                        <li className="comp-sub-3-part-list-3-inner">
                                                            <span>{t('comp-sub-3-text-14')}</span>
                                                        </li>
                                                        <li className="comp-sub-3-part-list-3-inner">
                                                            <span>{t('comp-sub-3-text-15')}</span>
                                                        </li>
                                                        <li className="comp-sub-3-part-list-3-inner">
                                                            <span>{t('comp-sub-3-text-16')}</span>
                                                        </li>
                                                        <li className="comp-sub-3-part-list-3-inner">
                                                            <span>{t('comp-sub-3-text-17')}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub4 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-4-headline')}</div>

                            {/* <div className="container-fluid col-12 col-md-10 d-flex justify-content-center">
                                <div className="col-12">
                                    <div className="comp-sub-description">
                                        <p>{t('comp-sub-4-text-1')}</p>
                                        <ul>
                                            <li className="comp-sub-3-part-list-2-inner"><span>{t('comp-sub-4-text-2')}</span></li>

                                            <li className="comp-sub-3-part-list-2-inner">
                                                <span>{t('comp-sub-4-text-3')}</span><br />
                                                <ul>
                                                    <li><span>{t('comp-sub-4-text-4')}</span></li>
                                                    <li><span>{t('comp-sub-4-text-5')}</span></li>
                                                    <li><span>{t('comp-sub-4-text-6')}</span></li>
                                                </ul>
                                            </li>
                                            <li className="comp-sub-3-part-list-2-inner"><span>{t('comp-sub-4-text-7')}</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
                            <div className="comp-sub-4-img-1"></div>
                            <div className="comp-sub-4-img-2"></div>
                        </div>
                        <div className={sub9 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-9-headline')}</div>
                            <div className="comp-sub-description">
                                <div className="container-fluid col-12 col-md-10 d-flex ">
                                    <p>{t('comp-sub-9-text-1')}</p>
                                </div>
                            </div>
                            <div className="comp-sub-description">
                                <div className="container-fluid col-12 col-md-8 col-lg-6 d-flex justify-content-between">
                                    <button className="btn btn-highlight06 w-100 py-1 mx-1" onClick={() => this.goToGroup('open_group')}><strong>{t('OPEN GROUP')}</strong></button>
                                    <button className="btn btn-highlight07 w-100 py-1 mx-1" onClick={() => this.goToGroup('academic_group')}><strong>{t('ACADEMIC GROUP')}</strong></button>
                                </div>
                            </div>
                            <div className="comp-sub-9-temp d-flex justify-content-center">
                                <div id="open_group" className="comp-sub-9-temp-1"></div>
                            </div>
                            <div className="comp-sub-9-temp d-flex justify-content-center">
                                <div id="academic_group" className="comp-sub-9-temp-2"></div>
                            </div>
                        </div>
                        <div className={sub5 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-5-headline')}</div>
                            <div className="comp1-timeline-content col-12">
                                <div className="comp1-timeline-content-btn"><a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border d-block w-100 h-100"> </a></div>
                            </div>
                            {/* <div className="text-center">
                                <h3 className="highlight01 pt-5">{t('comp-sub-5-text-1')}</h3>
                                <h5>{t('comp-sub-5-text-2')}</h5>
                                <h3 className="highlight01 pt-5">{t('comp-sub-5-text-3')}</h3>
                                <h5>{t('comp-sub-5-text-4')}</h5>
                                <h3 className="highlight01 pt-5">{t('comp-sub-5-text-5')}</h3>
                                <h5>{t('comp-sub-5-text-6')}</h5>
                                <h3 className="highlight01 pt-5">{t('comp-sub-5-text-7')}</h3>
                                <h5>{t('comp-sub-5-text-8')}<br />{t('comp-sub-5-text-9')}</h5>
                                <p className="p-5 m-5">{t('comp-sub-5-text-10')}</p>
                            </div> */}
                        </div>
                        <div className={sub6 ? "d-block col-12" : "d-none"}>
                            <h2 className="text-center my-4">{t('comp-sub-6-headline')}</h2>
                            <div className="container-fluid col-12 col-lg-10 d-flex flex-column">
                                <div className="comp-sub-6-section">
                                    {/* <div className="comp-sub-part-md comp-sub-6-part-1 d-flex justify-content-center col-12">
                                        <div className={t('comp-sub-part-headline-md d-flex align-items-center TXT_medium')}>{t('comp-sub-6-part-headline-1')}</div>
                                    </div> */}
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub1_Judge1} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp-sub-6-text-1')}</h4>
                                                <p className="">{t('comp-sub-6-text-2')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub1_Judge2} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp-sub-6-text-3')}</h4>
                                                <p className="">{t('comp-sub-6-text-4')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub1_Judge3} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp-sub-6-text-5')}</h4>
                                                <p className="">{t('comp-sub-6-text-6')}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub1_Judge4} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp-sub-6-text-7')}</h4>
                                                <p className="">{t('comp-sub-6-text-8')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub1_Judge5} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp-sub-6-text-9')}</h4>
                                                <p className="">{t('comp-sub-6-text-10')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub1_Judge6} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp-sub-6-text-11')}</h4>
                                                <p className="">{t('comp-sub-6-text-12')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub1_Judge7} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp-sub-6-text-13')}</h4>
                                                <p className="">{t('comp-sub-6-text-14')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub7 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-7-headline')}</div>
                            <div className="comp-sub-description">
                                <div className="container-fluid col-12 col-md-10">
                                    <p>{t('comp-sub-7-text-1')}</p>
                                    <p>{t('comp-sub-7-text-2')}</p>
                                </div>
                            </div>
                        </div>
                        <div className={sub8 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-8-headline')}</div>
                            <div className="container-fluid d-flex justify-content-center col-12">
                                <div className="comp-sub-part-detail col-12 col-md-10">
                                    <div className="comp-sub-description">
                                        <p>
                                            <div className="comp-sub-8-list">
                                                <ul>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-1')}</span><br />
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-2')}</span><br />
                                                        <ul>
                                                            <li><span>{t('comp-sub-8-text-3')}</span></li>
                                                        </ul>
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-4')}</span><br />
                                                        <ul>
                                                            <li><span>{t('comp-sub-8-text-5')}</span></li>
                                                        </ul>
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-6')}</span><br />
                                                        <ul>
                                                            <li><span>{t('comp-sub-8-text-7')}</span></li>
                                                        </ul>
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-8')}</span><br />
                                                        <ul>
                                                            <li><span>{t('comp-sub-8-text-9')}</span></li>
                                                            <li><span>{t('comp-sub-8-text-10')}</span></li>
                                                            <li><span>{t('comp-sub-8-text-11')}</span></li>

                                                        </ul>
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-12')}</span><br />
                                                        <ul>
                                                            <li><span>{t('comp-sub-8-text-13')}</span></li>
                                                            <li><span>{t('comp-sub-8-text-14')}</span></li>
                                                            <li><span>{t('comp-sub-8-text-15')}</span></li>
                                                        </ul>
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-16')}</span><br />
                                                        <ul>
                                                            <li><span>{t('comp-sub-8-text-17')}</span></li>
                                                            <li><span>{t('comp-sub-8-text-18')}</span></li>
                                                            <li>
                                                                <p>{t('comp-sub-8-text-19')}</p>
                                                                <p>{t('comp-sub-8-text-20')}</p>
                                                                <p><strong>{t('comp-sub-8-text-21')}</strong></p>
                                                                <p>{t('comp-sub-8-text-22')}</p>
                                                                <p>{t('comp-sub-8-text-23')}<br />{t('comp-sub-8-text-24')}</p>
                                                                <p>{t('comp-sub-8-text-25')}<br />{t('comp-sub-8-text-26')}</p>
                                                                <p>{t('comp-sub-8-text-27')}</p>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li className="comp-sub-8-list-inner comp-sub-8-list-ol">
                                                        <span className={t('TXT_bold')}>{t('comp-sub-8-text-28')}</span><br />
                                                        <ol>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-29')}</p>
                                                                <p>{t('comp-sub-8-text-30')}</p>
                                                            </li>
                                                            <li className="comp-sub-8-list-ol-inner">
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-31')}</p>
                                                                <ol>
                                                                    <li>
                                                                        <p>{t('comp-sub-8-text-32')}<a href={t('comp-sub-8-text-33')} target="_blank" rel="noopener noreferrer">{t('comp-sub-8-text-34')}</a>{t('comp-sub-8-text-35')}<a href={t('comp-sub-8-text-36')} target="_blank" rel="noopener noreferrer">{t('comp-sub-8-text-36')}</a>{t('comp-sub-8-text-37')}</p>
                                                                        <p>{t('comp-sub-8-text-38')}</p>
                                                                        <p>{t('comp-sub-8-text-39')}</p>
                                                                    </li>
                                                                    <li><p>{t('comp-sub-8-text-40')}</p></li>
                                                                </ol>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-41')}</p>
                                                                <p>{t('comp-sub-8-text-42')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-43')}</p>
                                                                <p>{t('comp-sub-8-text-44')}<a href={t('comp-sub-8-text-45')} target="_blank" rel="noopener noreferrer">{t('comp-sub-8-text-45')}</a>{t('comp-sub-8-text-46')}</p>
                                                                <p>{t('comp-sub-8-text-47')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-48')}</p>
                                                                <p><strong>{t('comp-sub-8-text-49-1')}</strong>{t('comp-sub-8-text-49')}</p>
                                                                <p>{t('comp-sub-8-text-50')}</p>
                                                                <p>{t('comp-sub-8-text-51')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-52')}</p>
                                                                <p>{t('comp-sub-8-text-53')}</p>
                                                                <p>{t('comp-sub-8-text-54')}</p>
                                                                <p>{t('comp-sub-8-text-55')}</p>
                                                            </li>
                                                            <li className="comp-sub-8-list-ol-inner">
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-56')}</p>
                                                                <p>{t('comp-sub-8-text-57')}</p>
                                                                <ol>
                                                                    <li className="comp-sub-8-list-ol-inner"><p>{t('comp-sub-8-text-58')}</p></li>
                                                                    <li className="comp-sub-8-list-ol-inner"><p>{t('comp-sub-8-text-59')}</p></li>
                                                                </ol>
                                                            </li>
                                                            <li className="comp-sub-8-list-ol-inner">
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-60')}</p>
                                                                <ol>
                                                                    <li><p>{t('comp-sub-8-text-61')}</p></li>
                                                                    <ol className="comp-sub-8-list-ol-inner-2">
                                                                        <li><p>{t('comp-sub-8-text-62')}<a href={t('comp-sub-8-text-63')} target="_blank" rel="noopener noreferrer">{t('comp-sub-8-text-63')}</a>{t('comp-sub-8-text-64')}</p></li>
                                                                        <li><p>{t('comp-sub-8-text-65')}</p></li>
                                                                        <li><p>{t('comp-sub-8-text-66')}</p></li>
                                                                        <li><p>{t('comp-sub-8-text-67')}</p></li>
                                                                    </ol>
                                                                    <li><p>{t('comp-sub-8-text-68')}</p></li>
                                                                </ol>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-69')}</p>
                                                                <ol className="comp-sub-8-list-ol-inner">
                                                                    <li><p>{t('comp-sub-8-text-70')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-71')}</p></li>
                                                                    <ul className="comp-sub-8-list-inner">
                                                                        <li><p>{t('comp-sub-8-text-72')}</p></li>
                                                                        <li><p>{t('comp-sub-8-text-73')}</p></li>
                                                                    </ul>
                                                                </ol>
                                                            </li>
                                                            <li className="comp-sub-8-list-ol-inner">
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-74')}</p>
                                                                <ol>
                                                                    <li><p>{t('comp-sub-8-text-75')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-76')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-77')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-78')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-79')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-80')}</p></li>
                                                                </ol>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-81')}</p>
                                                                <p>{t('comp-sub-8-text-82')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-83')}</p>
                                                                <p>{t('comp-sub-8-text-84')}</p>
                                                                <p>{t('comp-sub-8-text-85')}</p>
                                                                <p>{t('comp-sub-8-text-86')}</p>
                                                                <p>{t('comp-sub-8-text-87')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-88')}</p>
                                                                <p>{t('comp-sub-8-text-89')}</p>
                                                                <p>{t('comp-sub-8-text-90')}</p>
                                                                <p>{t('comp-sub-8-text-91')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-92')}</p>
                                                                <ol className="comp-sub-8-list-ol-inner">
                                                                    <li><p>{t('comp-sub-8-text-93')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-94')}</p></li>
                                                                    <li><p>{t('comp-sub-8-text-95')}</p>
                                                                        <ol className="comp-sub-8-list-ol-inner-2">
                                                                            <li><p>{t('comp-sub-8-text-96')}</p></li>
                                                                            <li><p>{t('comp-sub-8-text-97')}</p></li>
                                                                        </ol>
                                                                    </li>
                                                                </ol>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-98')}</p>
                                                                <p>{t('comp-sub-8-text-99')}</p>
                                                                <p>{t('comp-sub-8-text-100')}</p>
                                                                <p>{t('comp-sub-8-text-101')}</p>
                                                                <p>{t('comp-sub-8-text-102')}</p>
                                                                <p>{t('comp-sub-8-text-103')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-104')}</p>
                                                                <p>{t('comp-sub-8-text-105')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-106')}</p>
                                                                <p>{t('comp-sub-8-text-107')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-108')}</p>
                                                                <p>{t('comp-sub-8-text-109')}</p>
                                                                <p>{t('comp-sub-8-text-110')}</p>
                                                                <p>{t('comp-sub-8-text-111')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-112')}</p>
                                                                <p>{t('comp-sub-8-text-113')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-114')}</p>
                                                                <p>{t('comp-sub-8-text-115')}</p>
                                                            </li>
                                                            <li>
                                                                <p className={t('TXT_bold')}>{t('comp-sub-8-text-116')}</p>
                                                                <p>{t('comp-sub-8-text-117')}</p>
                                                            </li>
                                                        </ol>
                                                    </li>
                                                </ul>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <Footer />
                    {/*  Modal */}
                    <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content bg-black">
                                <div className="modal-body">
                                    <div className="d-flex justify-content-end">
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>


                                    <p>{t('alert-msg-1')}</p>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Comp);



// WEBPACK FOOTER //
// ./src/components/pages/comp.js